import React, { useCallback, useRef, useState } from 'react';
import { Image, UIText1, UIText2, useDeviceType } from '@cian/ui-kit';

import * as s from './BeforeAfterGallery.css';

export interface IBeforeAfterGallery {
  /** Картинка До */
  imageBefore: string;
  /** Картинка После */
  imageAfter: string;
}

/**
 * Галерея Было/Стало
 */
export const BeforeAfterGallery = ({ imageBefore, imageAfter }: IBeforeAfterGallery) => {
  const [offsetLeft, setOffsetLeft] = useState(50);
  const [isDraggable, setIsDraggable] = useState(false);
  const afterRef = useRef<HTMLDivElement>(null);
  const controlRef = useRef<HTMLDivElement>(null);
  const deviceType = useDeviceType();
  const UITextComponent = deviceType === 'phone' ? UIText2 : UIText1;

  /**
   * Передвигает шторку только с зажатой кнопкой мыши
   */
  const handleMouseMove = useCallback(
    (e: React.MouseEvent<HTMLDivElement>) => {
      if (!isDraggable) {
        return;
      }

      const positionLeft = e.clientX - e.currentTarget.offsetLeft;

      setOffsetLeft(positionLeft / (e.currentTarget.offsetWidth / 100));
    },
    [isDraggable],
  );

  /**
   * Передвигает шторку для touch-режима
   */
  const handleTouchMove = useCallback(
    (e: React.TouchEvent<HTMLDivElement>) => {
      if (!isDraggable) {
        return;
      }

      const positionLeft = e.touches[0].clientX - e.currentTarget.offsetLeft;

      if (positionLeft <= 0) {
        setOffsetLeft(0);

        return;
      } else if (positionLeft >= e.currentTarget.offsetWidth) {
        setOffsetLeft(100);

        return;
      }

      setOffsetLeft(positionLeft / (e.currentTarget.offsetWidth / 100));
    },
    [isDraggable],
  );

  return (
    <div
      className={s['wrapper']}
      onMouseLeave={() => setIsDraggable(false)}
      onMouseMove={handleMouseMove}
      onTouchMove={handleTouchMove}
      onTouchCancel={() => setIsDraggable(false)}
    >
      <Image loading={'lazy'} src={imageBefore} height={'100%'} borderRadius={0} objectFit={'cover'} />

      <div
        ref={controlRef}
        className={s['control']}
        onMouseDown={() => setIsDraggable(true)}
        onMouseUp={() => setIsDraggable(false)}
        onTouchStart={() => setIsDraggable(true)}
        onTouchEnd={() => setIsDraggable(false)}
        style={{ left: `${offsetLeft}%` }}
      />

      <div className={`${s['label']} ${s['_left']}`}>
        <UITextComponent color={'white_100'}>Было</UITextComponent>
      </div>

      <div className={`${s['label']} ${s['_right']}`}>
        <UITextComponent color={'white_100'}>Стало</UITextComponent>
      </div>

      {/* Невидимая картинка для создания пропорций */}
      <div className={s['back-image']}>
        <Image src={imageAfter} height={'100%'} objectFit={'cover'} />
      </div>

      <Image
        loading={'lazy'}
        width={`${100 - offsetLeft}%`}
        ref={afterRef}
        src={imageAfter}
        height={'100%'}
        borderRadius={0}
        objectFit={'cover'}
      />
    </div>
  );
};
